import { z } from "zod";

import { gcsDestinationSchema } from "./gcs/gcs-destination-schema";
import { s3DestinationSchema } from "./s3/s3-destination-schema";

export const destinationSchema = z.discriminatedUnion("type", [
  gcsDestinationSchema,
  s3DestinationSchema,
]);
